import React from "react";
import Box from "@mui/material/Box";
import {useDealContext} from "../../contexts/DealContext";

export const DealPageNotes = () => {
    const { dealState, setDealStateWithUpdate, isHistorical } = useDealContext()

    if (!dealState) return null;

    return (
        <Box className={'panel-notes'}>
            <div className={'panel-header'}>
                <div className={'panel-title'}>Notes</div>
            </div>
            <div className={'panel-body'}>
                <textarea
                    className={'description-input'}
                    placeholder={isHistorical ? '' : 'Add a note for this deal...'}
                    value={dealState.description || ''}
                    readOnly={isHistorical}
                    onChange={(e) => setDealStateWithUpdate({description: e.target.value})}
                />
            </div>
        </Box>
    )
}
